import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewprocessModal = ({ show, onHide, selectedItem, thStyle }) => {
  return (
    <Modal centered={true} show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Metting Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table">
          <thead></thead>
          <tbody>
            <tr>
              <th style={thStyle} colSpan={2}>Metting Type</th>
            </tr>
           
            <tr>
              <td>Meetings Type</td>
              <td>{selectedItem.name}</td>
            </tr>
            {/* <tr>
              <td>Date</td>
              <td>{selectedItem.created_at}</td>
            </tr> */}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewprocessModal;
